import React from 'react';

import {Colors, Text, Title} from '@optimaxdev/design-system';

import {Calendar, Icon, MoneyBack, Returns} from '@optimaxdev/icons';

import s from './shopWithConfidence.scss';

const ITEMS = [
    {
        height: 31,
        icon: MoneyBack,
        text: '100% money back guarantee',
    },
    {
        height: 24,
        icon: Returns,
        text: '14-day return or exchange',
    },
    {
        height: 29,
        icon: Calendar,
        text: '365-day warranty',
    },
];

/**
 * Right side component for CL TYP when not verification status
 */
export const ShopWithConfidence = () => {
    return (
        <div className={s.container}>
            <Title
                color={Colors.blueCharcoal}
                fontSize="20px"
                letterSpacing="normal"
                level={3}
                lineHeight="38px"
            >
                Shop with confidence:
            </Title>
            <ul className={s.items}>
                {ITEMS.map(({height, icon, text}) => (
                    <li className={s.item} key={text}>
                        <div className={s.iconWrapper}>
                            <Icon
                                color={Colors.limedSpruce}
                                height={height}
                                icon={icon}
                                strokeWidth={2}
                            />
                        </div>
                        <Text color={Colors.limedSpruce} lineHeight="normal" size="16px">
                            {text}
                        </Text>
                    </li>
                ))}
            </ul>
        </div>
    );
};
